import styled, { keyframes } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 0 12px;
`

export const ToolbarButton = styled.div<{ isActive: boolean; isDisabled?: boolean }>`
  width: 24px;
  height: 24px;
  background-color: ${Colors.Neutral10};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.Neutral70};

  &:hover {
    color: ${Colors.Blue60};
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: ${Colors.Blue60};
  `};

  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${Colors.Neutral40};
    pointer-events: none;
  `};
`

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 12px;
`

export const ToolbarDiv = styled.div`
  height: 20px;
  width: 1px;
  margin: 0 10px;
  background-color: ${Colors.Neutral30};
`

export const LinkElement = styled.a`
  color: ${Colors.Blue50};
`

export const SpellCheckIconWrapper = styled.div`
  position: relative;
`

export const SpellCheckPendingDots = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 3px;
  bottom: 3px;
`

const pending = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`

export const SpellCheckPendingDot = styled.div`
  width: 3px;
  height: 3px;
  margin-right: 2px;
  background-color: ${Colors.Blue50};
  border-radius: 50%;
  opacity: 0;
  animation: ${pending} 1.5s infinite linear;

  &:last-child {
    margin: 0;
  }
`

export const SpellCheckPendingFirstDot = styled(SpellCheckPendingDot)``

export const SpellCheckPendingSecondDot = styled(SpellCheckPendingDot)`
  animation-delay: 0.2s;
`

export const SpellCheckPendingThirdDot = styled(SpellCheckPendingDot)`
  animation-delay: 0.4s;
`
